import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import FancySlider from '../elements/FancySlider'
import Detail from '../elements/Detail'
import store from '../store'
import globals from '../globals'

const options = {
    postUrl: '/api/postCapSpend',
    success: 'Success! Your capped spend amount has been updated.'
}

const state = {
    serviceId: '',
    amount: 0
}

class CapMySpendForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    componentDidUpdate (prevProps) {
        if (prevProps.cappedSpend !== this.props.cappedSpend) {
            this.props.setDynamicValues({
                amount: this.props.cappedSpend && this.props.cappedSpend > 0 ? this.props.cappedSpend : 0
            })
        }
    }

    render () {
        const calcTotal = () => {
            return globals.addDecimals(parseFloat(this.props.values.monthlyFee) + parseFloat(this.props.values.amount), true)
        }

        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRowReadOnly label='My mobile number' value={this.props.values.mobile} />
                <InputRowReadOnly label='My monthly plan fee' value={globals.addDecimals(this.props.values.monthlyFee, true)} />
                {this.props.cappedSpend && this.props.cappedSpend > 0 ? <InputRowReadOnly label='My current excess spend cap' value={globals.addDecimals(this.props.cappedSpend, true)} /> : ''}

                <div className='row mt-3'>
                    <div className='col-12'>
                        <p className='font-medium text-center'>Cap my monthly excess spend at:</p>
                        <FancySlider name='amount' min='0' max='100' step='10' value={this.props.values.amount} setValue={amount => this.props.setDynamicValues({ amount: amount })} display={amount => `$${amount}`} />
                    </div>
                </div>

                <div className='row text-center mb-2'>
                    <div className='col-6'>
                        <Detail title='Maximum monthly cost' value={calcTotal()} />
                    </div>
                    <div className='col-6'>
                        <Detail title='Billed to' value={store.getState().auth.paymentVia} />
                    </div>
                </div>

                {this.props.children}

                <div className='mt-2 d-flex align-items-center flex-column flex-md-row'>
                    <div className='mr-4 flex-shrink-0'>
                        <Button title='Submit Change' action={this.props.handleSubmit} />
                    </div>
                    <div>
                        <p><small>
                            You will receive an email and SMS notification of this change and when you hit 50%, 85% and 100% of your excess spend limit.
                           </small>
                        </p>
                    </div>
                </div>
            </form>
        )
    }
}

export default FormHOC(CapMySpendForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/CapMySpendForm.js